/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cps: NonNullable<unknown> }} Event_Warning_Cps_TitleInputs */



/**
* | output |
* | --- |
* | "CPS warning: CPS ({cps}) is above max value" |
*
* @param {Event_Warning_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_cps_title = /** @type {((inputs: Event_Warning_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Alerte CPS : le CPS (${i?.cps}) dépasse la valeur maximale`)
	if (locale === "de") return /** @type {LocalizedString} */ (`CPS-Warnung: CPS (${i?.cps}) liegt über dem Maximalwert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Avviso CPS: CPS (${i?.cps}) è superiore al valore massimo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Предупреждение CPS: значение CPS (${i?.cps}) превышает максимальное значение.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Advertencia de CPS: CPS (${i?.cps}) está por encima del valor máximo`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`CPS 警告：CPS (${i?.cps}) 高于最大值`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CPS警告: CPS (${i?.cps})が最大値を超えています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सीपीएस चेतावनी: सीपीएस (${i?.cps}) अधिकतम मान से अधिक है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Aviso do CPS: O CPS (${i?.cps}) está acima do valor máximo.`)
	return /** @type {LocalizedString} */ (`CPS warning: CPS (${i?.cps}) is above max value`)
});